import script from "./ProjectFloorsWork.vue?vue&type=script&setup=true&lang=js"
export * from "./ProjectFloorsWork.vue?vue&type=script&setup=true&lang=js"

import "./ProjectFloorsWork.vue?vue&type=style&index=0&id=80b32c56&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-80b32c56"]])

export default __exports__
import QIcon from 'quasar/src/components/icon/QIcon.js';
import QLinearProgress from 'quasar/src/components/linear-progress/QLinearProgress.js';
import QTr from 'quasar/src/components/table/QTr.js';
import QTh from 'quasar/src/components/table/QTh.js';
import QDialog from 'quasar/src/components/dialog/QDialog.js';
import QCard from 'quasar/src/components/card/QCard.js';
import QCardSection from 'quasar/src/components/card/QCardSection.js';
import QCardActions from 'quasar/src/components/card/QCardActions.js';
import QBtn from 'quasar/src/components/btn/QBtn.js';import ClosePopup from 'quasar/src/directives/close-popup/ClosePopup.js';
import qInstall from "../../../node_modules/vue-cli-plugin-quasar/lib/runtime.auto-import.js";
qInstall(script, 'components', {QIcon,QLinearProgress,QTr,QTh,QDialog,QCard,QCardSection,QCardActions,QBtn});qInstall(script, 'directives', {ClosePopup});
